// @flow

import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import Masthead from '@ta-interaktiv/react-masthead'
import Cover from 'components/cover'
import UserFeedback from '@ta-interaktiv/react-user-feedback'
import { ThemeSwitch as themeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Waypoint } from 'react-waypoint'
import Tipp from 'components/tipp'
import Scrollchor from 'react-scrollchor'
import { Footer } from '@ta-interaktiv/react-footer'


const ARTICLE_ID = '25890934'

// region Images
const spyri = require('./johanna-spyri.jpg?sizes=640w+800w+1280w+1600w')
const rampling = require('./charlotte-rampling.jpg?sizes=640w+800w+1280w+1600w')
const rosenwasser = require('./annemarie-schwarzenbach.jpg?sizes=640w+800w+1280w+1600w')
const carobbio = require('./marie-curie.jpg?sizes=640w+800w+1280w+1600w')
const kureyshi = require('./meret-oppenheim.jpg?sizes=640w+800w+1280w+1600w')
const neff = require('./johanna-von-orleans.jpg?sizes=640w+800w+1280w+1600w')
const theus = require('./zaha-hadid.jpg?sizes=640w+800w+1280w+1600w')
const miller = require('./olympe-de-gouges.jpg?sizes=640w+800w+1280w+1600w')
const keller = require('./iris-von-roten.jpg?sizes=640w+800w+1280w+1600w')


// no-unused-vars
const sizesForTextContainer = '(max-width: 599px): 95vw, 581px'
// endregion

type Props = {}

type State = {
  isLoading: boolean,
  publicationDate: number
}

class AppComponent extends Component<Props, State> {
  state = {
    isLoading: true,
    publicationDate: Date.now() / 1000
  }

  constructor(props) {
    super(props)
    this.trackNavClicks = this.trackNavClicks.bind(this)
    this.trackTopClicks = this.trackTopClicks.bind(this)
    // TODO Change if you want to use a different style sheet from
    // interaktiv.tagesanzeiger.ch/static/themes/
    themeSwitch({ mediaName: 'dasmagazin' })
  }

  trackNavClicks(e) {
    let clickedText = e.currentTarget.firstChild.nodeValue
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'item: ' + clickedText
    })
  }


  trackTopClicks (e) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toTop: '
    })
  }


  componentDidMount() {
    const domain = parseHostname().publicationDomain
    return fetch(`https://m.${domain}/api/articles/${ARTICLE_ID}`)
      .then(response => response.json())
      .then(data => {
        this.setState({
          publicationDate: data.article.first_published_at,
          isLoading: false
        })
      })
      .catch(error => {
        console.warn(error)
      })
  }

  render() {
    return (
      <div className='index'>
        <Masthead
          inverted
          articleId={ARTICLE_ID}
          mediaName={'dasmagazin'}
          fullMediaName={'Das Magazin'}
          homepage={'https://www.dasmagazin.ch'}
        />
        <header className='ui vertical fitted segment first'>
          <div
            className='ui inverted segment'
            style={{
              margin: 0,
              position: 'absolute',
              backgroundColor: 'transparent',
              zIndex: 99,
              width: '100%'
            }}
          >

          </div>
          <Cover
            title='FRAUEN ÜBER <br /> DIE FRAU, DIE SIE INSPIRIERT'
            titleTwo='FRAUEN ÜBER DIE FRAU, DIE SIE INSPIRIERT'
            // author='ANUSCHKA ROSHANI & PAULA SCHEIDT'
          />
          <figcaption className='ui container'>
            Bild: Meret Oppenheim
          </figcaption>
        </header>

        <Waypoint scrollableAncestor={window} onLeave={(event) => {
          if (event.currentPosition === Waypoint.above) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event' : 'Interactions',
              'event_action' : 'vertical-scroll',
              'event_label' : 'startReading'
            }
            )
          }
        }} />

        <div className='ui text container'>
          <p className='ma author' style={{ fontWeight:'600' }}>
            VON ANUSCHKA ROSHANI & PAULA SCHEIDT
          </p>

          <p>
          Wenn beide Glück miteinander haben, ist die Mutter lange das erste weibliche
          Vorbild für die Tochter, denn das Lebenlernen geschieht vor allem übers Nachahmen.
          Wenn die Tochter weiterhin Glück hat, wird sie auf ihrem Weg anderen Frauen begegnen,
          die ihr gekonnt vormachen, wonach sie selbst strebt.
          </p>

          <p>
          Spätestens an diesem Punkt beginnt das Dilemma: Zum einen ist es nicht immer
          leicht, genau zu wissen, was man für sich erreichen möchte. Zum anderen ist
          es nicht immer leicht, diejenigen ausfindig zu machen, die in der Praxis das
          verkörpern, was man theoretisch für sich will – das jedoch liegt auch an der
          Praxis selbst. Zumindest im Beruflichen sind Frauen zu oft noch zu wenig sichtbar,
          als dass man sich an ihnen ein Beispiel nehmen könnte – oder, milde gesagt, als
          junge Frau hat man kein Panorama von lauter eindrucksvollen Frauen vor Augen.
          Aber es gibt sie und hat sie immer gegeben.
          </p>

          <p>
          Während mehrerer Jahrzehnte waren sie auf den unterschiedlichsten Feldern erfolgreich.
          Jetzt hat eine Phase der Überprüfung begonnen: Wie sehr spiegelt sich der
          gesellschaftliche Konsens, dass Frauen und Männer die gleichen Rechte haben,
          im Alltag? Dieses Hinterfragen zeigt sich etwa an Ereignissen wie dem nationalen
          Frauenstreiktag, aber auch daran, dass die Gleichbehandlung
          wieder überall Thema ist.
          </p>

          <p>
          Wir möchten einige Vorkämpferinnen vorstellen und an andere erinnern.
          Deshalb haben wir 12 grossartige Frauen aus der Schweiz gebeten, uns ihre
          Heldin zu präsentieren. Wenn man so will, also von einer Frau zu schwärmen,
          die für sie wichtig ist – und wir freuen uns, dass es in dieser Sonderausgabe
          gelingt, sogar die Toten für uns quicklebendig zu machen.
          </p>

          <ul className='nav' id='nav'>
            <Scrollchor animate={{ offset: -40 }} to='#laeri'>
              <li onClick={this.trackNavClicks}>
                Patrizia Laeri über <span className='bold'>JOHANNA SPYRI</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#lardi'>
              <li onClick={this.trackNavClicks}>
                Ursina Lardi über <span className='bold'>CHARLOTTE RAMPLING</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#burri'>
              <li onClick={this.trackNavClicks}>
                Nina Burri über <span className='bold'>CARLA DEL PONTE</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#rosenwasser'>
              <li onClick={this.trackNavClicks}>
                Anna Rosenwasser über <span className='bold'>ANNEMARIE SCHWARZEN&shy;BACH</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#koerfer'>
              <li onClick={this.trackNavClicks}>
                Lou Koerfer über <span className='bold'>GRETA THUNBERG</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#neff'>
              <li onClick={this.trackNavClicks}>
                Jolanda Neff über <span className='bold'>JOHANNA VON ORLÉANS</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#falk'>
              <li onClick={this.trackNavClicks}>
                Francesca Falk über <span className='bold'>LILIANE VALCESCHINI</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#carobbio'>
              <li onClick={this.trackNavClicks}>
                Marina Carobbio über <span className='bold'>MARIE CURIE</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#kureyshi'>
              <li onClick={this.trackNavClicks}>
                Meral Kureyshi über <span className='bold'>MERET OPPENHEIM</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#theus'>
              <li onClick={this.trackNavClicks}>
                Tilla Theus über <span className='bold'>ZAHA HADID</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#miller'>
              <li onClick={this.trackNavClicks}>
                Barbara Miller über <span className='bold'>OLYMPE DE GOUGES</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
            <Scrollchor animate={{ offset: -40 }} to='#keller'>
              <li onClick={this.trackNavClicks} style={{ borderBottom: '1px solid #ccc' }}>
                Ann-Sophie Keller über <span className='bold'>IRIS VON ROTEN</span> <i className='tiny icon chevron down' />
              </li>
            </Scrollchor>
          </ul>
        </div>


        <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === Waypoint.below) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event' : 'Interactions',
              'event_action' : 'vertical-scroll',
              'event_label' : '10ContentRead'
            }
            )
          }
        }} />


        <div
          className='ui container titleContainer'
          id='laeri'
        >
          <div className='oberzeile'>
            <p className='test'><span className='bold'>Patrizia Laeri <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>JOHANNA SPYRI</h2>
          <h4 className='titleTwo'>|&nbsp;Frauen ein Gesicht geben: früher in Romanen, heute im Internet&nbsp;|</h4>
          <p className='autor'>
            PATRIZIA LAERI (42) ist Wirtschaftsjournalistin, TV-Moderatorin von «SRF Börse» und «ECO».
            Zudem moderiert sie seit Jahren am WEF und war Mitinitiatorin des Edit-a-thon «Frauen für
            Wikipedia», bei dem weibliche Biografien für Wikipedia verfasst werden.
          </p>
        </div>

        <div className='ui text container'>

              <p>Ich muss von Heidis Geschichte erfahren haben, als ich selbst noch gar
              nicht lesen konnte. Meine Grossmutter heisst Heidi. Sie wohnte in Maienfeld
              und pflegte uns jeden Abend ein paar Seiten aus den «Heidi»-Büchern vorzulesen.
              Wir sind dann in ihrem grossen Bett eingeschlummert, als wären wir da oben auf
              der Alp bei Heidi im Heuboden. Tagsüber nahm unsere Nani uns oft mit zum
              Heidi-Brunnen und zum Dörfli. Sie verehrte Johanna Spyri. Vielleicht auch,
              weil das Buch gütige, aber ebenso starke Grossmütter zeigt.</p>
              <img
                src={spyri.sources['1280w']}
                srcSet={spyri.srcSet}
                sizes={'100vw'}
                alt='Johanna Spyri (1827–1901), Autorin der «Heidi»-Bücher'
                className='ui fluid image'
                style={{
                  width: '80%',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              />
              <figcaption className=''>
                Johanna Spyri (1827–1901), Autorin der «Heidi»-Bücher. <span className='textAutor'>ILLUSTRATION: CLAUDIA BLUM</span>
              </figcaption>

              <p>Aber es zeigt auch das Waisenkind Heidi, das niemand haben will, das
              abgeschoben, weitergereicht, schliesslich gar ins Ausland verliehen wird.
              Viele Menschen wären daran zerbrochen. Sie aber ist zäh. Unverdorben, wild,
              naturverbunden. Heidi entspricht keinem gängigen Schönheitsideal, mit dem
              widerspenstigen Haar und den schwarz funkelnden Augen. Sie passt nicht in die
              Rollenklischees der üblichen Kinderbücher. Heidi hat ihren eigenen Kopf. Sie
              führt uns aber auch in eine Welt bitterer Armut, misstrauischer Menschen und
              harter Sitten.</p>

              <p>Mit Heidi habe ich begonnen, meiner Mutter Fragen zu stellen, über Armut,
              die Schule und das Leben damals im Bündnerland. Die Antworten waren brutal.</p>

              <p>Das Kindsein meiner Mutter war Schwerstarbeit. Sie half ihrer Mutter, im eisigen
              Brunnenwasser die Wäsche zu spülen. Der Vater hatte ein bisschen Land und Vieh, aber
              eben nicht genug, sodass er zusätzlich Schichten in der Fabrik schob. Meine Mutter
              arbeitete als Älteste von morgens bis abends im Haushalt oder bei der Heuete. Das
              zierliche Kind schleppte so schwer, dass es sich den Rücken kaputt trug. Weihnachten
              hiess, aus Katalogen Spielzeug ausschneiden und auf Packpapier kleben. Aber es gab
              noch ärmere Kinder. Die gingen im Winter barfuss durch den Schnee zur Schule und
              verliessen sie windelweich geprügelt und humpelnd.</p>

              <p>Meine Mutter flüchtete sich in die Natur und zu den Grosseltern. Am glücklichsten
              war sie, wenn sie die Sommer mit ihnen im Maiensäss verbringen durfte. Mit zwölf
              Jahren wurde sie als Magd verliehen. Da stand sie Ängste aus, die ich hier nicht
              niederschreiben kann, weil sie nicht auszuhalten sind. Nachts, wenn der versoffene
              Bauer nach Hause polterte, verbarrikadierte sie sich in ihrem Zimmer. Wie durch ein
              Wunder überlebte sie unbeschadet. Manches andere Mädchen damals nicht.
              </p>

              <p>
              Johanna Spyri hat auch über all dieses Düstere geschrieben. In anderen Erzählungen
              schrieb sie über Missbrauch, Inzest, Gewalt und immer wieder über bittere Armut. Sie
              zeigte das Leben in der Schweiz während der frühen Industrialisierung, und sie gab die
              Hauptrollen den Frauen. Eine Rarität in der literarischen Welt von 1879. Dennoch wurde
              «Heidi» in kürzester Zeit zum Welterfolg. Mittlerweile ist es eines der meistverkauften
              Bücher aller Zeiten, das bekannteste Werk der Schweizer Literatur. Es wurde in mehr als
              fünfzig Sprachen übersetzt.
              </p>

              <p>Noch immer ist die Literatur- und Filmwelt sehr männlich. Jungs und Männer spielen
              die Hauptrollen, auch in Hollywood. Datenanalysen zeigen: Schon in Disney-Filmen für
              Kinder sprechen die meiste Zeit Männer – selbst wenn die Hauptfigur weiblich ist.
              </p>

              <p>Es macht mich wütend, dass meine Mutter fast dreissig Jahre lang ohne Stimmrecht
              war, ein Mensch zweiter Klasse, so wie alle weiblichen Figuren Spyris. Sie durfte
              keinen Beruf erlernen – was sie heimlich trotzdem tat.
              </p>

              <p>
                Meine Mutter und Johanna Spyri sind der Grund, warum ich nie ruhen werde, mich für
                Frauen einzusetzen. Und sei es nur, damit Frauen in den Medien endlich die gleiche
                Redezeit erhalten wie Männer. Oder damit auf Wikipedia, der wichtigsten digitalen
                Informationsseite der Welt, auch Frauen gewürdigt werden.
              </p>
              <p>
                Frauen sichtbar machen, über sie schreiben, sie befragen – das ist mir wichtig.
                Nur so kann ich mit meiner Wut über Unterdrückung und Ungerechtigkeit umgehen. Darin
                fühle ich mich Johanna Spyri verbunden.
              </p>

              <p className='textAutor'>TEXT: PATRIZIA LAERI</p>

        </div>

        <div
          className='ui container titleContainer'
          id='lardi'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Ursina Lardi <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>CHARLOTTE RAMPLING</h2>
          <h4 className='titleTwo'>|&nbsp;Nackt vor die Kamera treten, trotzdem kein Sexobjekt sein&nbsp;|</h4>
          <p className='autor'>
            URSINA LARDI (48), aufgewachsen in Graubünden, spielt im Ensemble der Schaubühne Berlin.
            Neben ihrer Theaterarbeit ist sie in zahlreichen Fernseh- und Kinofilmen zu sehen, 2014
            erhielt sie den Schweizer Filmpreis.
          </p>
        </div>

        <div className='ui text container'>

            <p><span className='question'>Das Magazin: Frau Lardi, wofür bewundern Sie Ihre Schauspielkollegin Charlotte Rampling?
              </span><br />
              Ursina Lardi: Mir gefällt an ihr, wie sie immer wieder die Grenzüberschreitung sucht, und das
              auf so elegante Art und Weise. Dieser kleine Schritt, den sie zu weit geht, der macht einen
              hellwach, etwa in «Max Mon Amour» von Nagisa Oshima: Kein Gepolter, kein Gebrüll, die Frisur
              sitzt, tadelloses Make-up, aber der Geliebte neben ihr im Bett ist ein Schimpanse.
            </p>

            <img
              src={rampling.sources['1280w']}
              srcSet={rampling.srcSet}
              sizes={'100vw'}
              alt='Charlotte Rampling (73), britische Schauspielerin und Sängerin'
              className='ui fluid image'
            />
            <figcaption className=''>
              Charlotte Rampling (73), britische Schauspielerin und Sängerin. <span className='textAutor'>ILLUSTRATION: JEANNE DETALLANTE</span>
            </figcaption>

            <p><span className='question'>Rampling hat sehr viel mit Nacktheit gearbeitet in ihren Filmen.
              </span><br />
              Das stimmt. In «The Look», einem Dokumentarfilm über sie, fällt der Satz: Film ist ein Medium von Männern für Männer, die schöne Frauen auf grosser Leinwand sehen wollen. Dieses Machtverhältnis hat sie umgedreht, und das schon als sehr junge Frau. Auch nackt wurde sie nie zum Objekt – durch ihren Blick, eben durch the look, behielt sie immer das Heft in der Hand. So hat ja das Verb to rample sogar Eingang in die englische Sprache gefunden: «einen Mann durch kühle, nicht fassbare Sexualität wehrlos machen».
            </p>

            <p><span className='question'>Wäre sie nur intelligent und nicht so schön, wäre das vermutlich nicht aufgegangen.
              </span><br />
              Es war die Kombination – ihre umwerfende Schönheit, der klare Blick und ihre Klugheit.
              Ihr war immer bewusst, diese Art von Schönheit, das ist eine kurze Sache. Heute ist
              sie über siebzig, noch immer eine sehr schöne Frau und noch immer oft nackt zu sehen.
              Sie selbst unterscheidet Sinnlichkeit und Sexualität. Sinnlich, sagt sie, bleibt man
              ein Leben lang, und das ist es, was anziehend macht. Sie ärgert sich übrigens sehr,
              wenn man sagt, es sei mutig von ihr, sich in ihrem Alter nackt zu zeigen. Was soll
              daran mutig sein? So sieht ein Mensch aus – mit zwanzig, mit fünfzig, mit siebzig,
              das ist alles.
            </p>

            <p><span className='question'>Sie selbst sind seltener nackt zu sehen, und wenn, dann nicht in erotischen Rollen. Ist das eine bewusste Entscheidung?
              </span><br />
                Ja, wenn ich heute in meinen Rollen am Theater oder im Film etwas über Nacktheit
                erzähle, hat das selten mit Erotik zu tun. Es geht mir mehr um die Entblössung,
                die Fleischlichkeit – nackt im Sinne einer seelischen Nacktheit, eines
                Ausgesetztseins. Deshalb hat mich das als künstlerisches Mittel auch erst
                begonnen zu interessieren, als ich älter wurde und der Körper nicht mehr
                perfekt war. Als junge Frau hatte ich Angst, zum Objekt zu werden. Ich
                kannte eben Frau Rampling noch nicht... (lacht)
            </p>

            <p><span className='question'>Man sagt ja, für Schauspielerinnen werde es ab einem bestimmten Alter schwieriger, Rollen zu bekommen.
              </span><br />
              Das stimmt wohl, ich persönlich habe es aber ganz anders erlebt. Ich habe noch
              nie so interessante Rollen gespielt wie in den letzten Jahren und auch noch nie
              so viel Geld verdient. Charlotte Rampling ist mit über siebzig noch immer sehr
              gefragt. Ich denke, da ist Bewegung in die Sache gekommen, und das Problem wird
              es hoffentlich bald nicht mehr geben.
            </p>

            <p><span className='question'>Viele Schauspielerinnen lassen sich operieren, um den kritischen Punkt hinauszögern.
              </span><br />
              Mir gefällt Ramplings Totalverweigerung, sich operativen Eingriffen zu
              unterziehen. Natürlich werde ich auch nichts an meinem Gesicht machen
              lassen, selbst wenn nicht immer erfreulich ist, was man morgens um 6.30 Uhr
              im Spiegel der Maske sehen muss... Schlachten, die nicht zu gewinnen sind,
              sollte man meiden. Rampling sagte mal, es interessiere sie einfach, was es
              bedeutet, ein Mensch zu sein und als Mensch zu altern, sie wolle alles
              mitbekommen, was die Zeit mit ihr und ihrem Gesicht macht. Das finde ich
              souverän. Ich denke, die Fülle ihrer Filmrollen über einen so langen
              Zeitraum wird eines Tages ein sehr authentisches Dokument dieser Aussage
              sein, weil für Rampling, wie sie sagt, die Karriere nur Begleiterscheinung
              ihres Lebens ist und sie ausschliesslich Filme macht, die etwas mit ihr und
              mit ihrer jeweiligen Verfasstheit zu tun haben – die also sehr persönlich sind.
            </p>

            <p><span className='question'>Sie selbst sind derzeit vor allem auf der Bühne zu sehen – ziehen Sie das Theater dem Film vor?
              </span><br />
              Nein, nicht unbedingt, ich möchte beides machen, bin aber bis jetzt beim Theater
              künstlerisch weiter gekommen als beim Film, da sind noch einige Rechnungen offen.
              Das Theater bietet mir mehr Freiheit. Meine letzten Rollen waren ein 17-jähriger
              Tennisprofi, der sterbende Lenin und eine Entwicklungshelferin im Kongo. Im Theater
              gibt es nichts, was man nicht spielen kann, ich bin da nicht an mein Alter oder
              mein Geschlecht gebunden. Ich werde übrigens fast nie auf der Strasse erkannt,
              was sehr angenehm ist. Auch am Wiedererkennungseffekt auf der Bühne liegt mir
              nichts; wenn es gut läuft, ist jede Rolle eine Neuschöpfung. Für mich muss eine
              Rolle Platz haben für Unaussprechliches, was man eben nur spielen kann, egal,
              ob auf der Bühne oder im Film. Es darf auch lustig sein, gerne auch an unpassenden
              Stellen. Wenn eine Rolle, ein Theaterstück, ein Film ganz ohne Humor ist, dann
              stimmt etwas nicht.
            </p>

            <p className='textAutor'>INTERVIEW: PAULA SCHEIDT</p>

        </div>

        <div
          className='ui container titleContainer'
          id='burri'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Nina Burri <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>CARLA DEL PONTE</h2>
          <h4 className='titleTwo'>|&nbsp;Karriere machen im internationalen Strafrecht und vor nichts Angst haben&nbsp;|</h4>
          <p className='autor'>
            NINA BURRI (35) ist Staatsanwältin am Internationalen Strafgerichtshof in Den Haag.
          </p>
        </div>

        <div className='ui text container'>

            <p>
              Einmal fuhren Carla Del Ponte und ich in einer gepanzerten Limousine durch
              Buenos Aires, und sie sagte zu mir: «Wenn Sie wirklich was bewegen wollen –
              gehen Sie zur UNO!» Das war 2009, ich absolvierte ein Praktikum an der
              Schweizer Botschaft in Argentinien, und Del Ponte war dort Botschafterin.
              Es waren ihre letzten drei Jahre vor der Pension. Ich hätte auch nach Ghana
              oder in ein anderes Land an die Botschaft gehen können, ebenfalls spannend,
              aber wegen Del Ponte hatte ich mich für Argentinien entschieden. Ich durfte
              sie zu Terminen begleiten, so lernte ich sie persönlich kennen.
            </p>

            <p>
              Aus der Ferne hatte ich ihre Karriere schon lange verfolgt. Als ich 16
              war, wurde sie Chefanklägerin der Internationalen Straftribunale für die
              Kriegsverbrechen im ehemaligen Jugoslawien und Ruanda. Es war die Zeit,
              als ich begann, über meine berufliche Zukunft nachzudenken. Dass jemand
              aus der Schweiz, noch dazu eine Frau, in so eine Position kam, das hat
              mich geprägt. Es hat mir die Gewissheit gegeben, dass es auch auf
              internationaler Ebene möglich ist. Das war wie nach den Sternen greifen.
              Alles, was über sie berichtet wurde, habe ich gelesen.
            </p>

            <p>
              Als ich in Argentinien war, erschien ihr erstes Buch, «Im Namen der Anklage».
              Das habe ich mir sofort gekauft.
            </p>

            <p>
              Was ich an Carla Del Ponte bewundere: Sie ist mutig. Sie sagt, was sie
              denkt. Und sie sagt es auch, wenn niemand es hören will. Diesen Mut,
              unbequem zu sein, der beeindruckt mich. Dafür zahlt sie einen hohen
              Preis: Seit sie sich als Staatsanwältin im Tessin mit der Mafia angelegt
              hat, wird sie von Bodyguards begleitet. Als sie im Sommer 1989 ihren
              italienischen Staatsanwaltskollegen Giovanni Falcone in Palermo besuchte,
              wurde auf dem Weg zu seinem Ferienhaus eine Tasche mit Dynamit gefunden.
              Sie hätte die beiden umbringen sollen. 1992 stirbt Falcone, ermordet von
              der sizilianischen Mafia. Aber Del Ponte ist keine, die sich
              einschüchtern lässt.
            </p>

            <p>
              Sie schont sich nicht. Sie schaut genau hin, auch wenn es unangenehm ist.
              Das haben wir gemeinsam. Seit einem guten Jahr arbeite ich nun selbst am
              Internationalen Strafgerichtshof in Den Haag im Büro der Chefanklägerin.
              Ich untersuche Kriegsverbrechen, Verbrechen gegen die Menschlichkeit und
              Völkermord. Unsere Experten gehen ins Feld, kommen mit Beweisen zurück,
              und ich analysiere sie dann und entscheide: Reicht das, um jemanden anzuklagen?
              Es sind riesige Fälle mit Hunderten Straftaten und Opfern. Wir konzentrieren
              uns hauptsächlich auf die politischen und militärischen Führer, für
              die unteren Hierarchiestufen sind die Staaten selbst verantwortlich.
              Ich muss tagtäglich teils grausame Fotos und Videos ansehen, Folter,
              sexuelle Gewalt, Vertreibungen, aber ich kann mich gut abgrenzen. Viele
              Menschen finden zu Recht, das sei zu schlimm. Mich hingegen zieht das an.
              Ich finde es zu wichtig, als dass ich wegschauen kann. Und Carla Del Ponte auch.
            </p>

            <p>
              Die internationale Strafjustiz ist noch sehr jung, und Carla Del Ponte
              hat sie massgeblich mitgeprägt. Eins hat sich dort in den letzten zwanzig
              Jahren leider nicht geändert: Obwohl es sehr viele hoch qualifizierte und
              kompetente Frauen gibt, besteht die oberste Führungsetage zu achtzig Prozent
              aus Männern.
            </p>

            <p>
              Es gibt auch viele Unterschiede zwischen Carla Del Ponte und mir. Sie ist
              sehr politisch. Ich bin das ebenfalls, interessiere mich aber auch sehr für
              die komplexe juristische Materie. Meine Stelle hier in Den Haag ist von der
              Schweiz für zwei Jahre gesponsert. Ich schliesse nicht aus, wie Del Ponte
              einmal ein höheres Amt in der internationalen Strafjustiz anzustreben. Aber
              mich reizt auch die Tätigkeit als Staatsanwältin oder Anwältin in der Schweiz.
              Auch vom Charakter haben wir eigentlich wenig Ähnlichkeiten. Aber allein zu
              sehen, dass es so einen Typ Frau wie sie gibt, so anders als die Frauen, die
              ich vorher kannte, so direkt, so stark, so kompromisslos – das hat mich sehr
              inspiriert.
            </p>

            <p>
              In gewisser Weise habe ich ihren Rat damals befolgt, zur UNO zu gehen: Der
              Internationale Strafgerichtshof in Den Haag ist ja aus den UNO-Tribunalen entstanden.
            </p>

            <p className='textAutor'>PROTOKOLL: PAULA SCHEIDT</p>

        </div>

        <div
          className='ui container titleContainer'
          id='rosenwasser'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Anna Rosenwasser <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>ANNEMARIE SCHWARZEN&shy;BACH</h2>
          <h4 className='titleTwo'>|&nbsp;Frauen begehren ohne Schuldgefühl&nbsp;|</h4>
          <p className='autor'>
            ANNA ROSENWASSER (30) ist Aktivistin, Journalistin und leitet die Öffentlichkeitsarbeit
            der LOS, der Lesbenorganisation Schweiz. Sie kämpft für die Ehe für alle und für das Antidiskriminierungsgesetz.
          </p>
        </div>

        <div className='ui text container'>

            <p>
              Du wächst auf und glaubst, du seist die Einzige auf der Welt.
              Es macht dich krank, es macht fast alle von uns krank. Frauenliebende
              Frauen werden von den Medien unsichtbar gemacht. Wenn es um die Ehe
              für alle geht, heisst die Schlagzeile: «Schwulenehe!», beim Antidiskriminierungsgesetz:
              «Schwulengesetz!» – What the fuck?
            </p>

            <img
              src={rosenwasser.sources['1280w']}
              srcSet={rosenwasser.srcSet}
              sizes={'100vw'}
              alt='Annemarie Schwarzenbach (1908–1942), Fotografin, Autorin und Weltreisende'
              className='ui fluid image'
            />
            <figcaption className=''>
              Annemarie Schwarzenbach (1908–1942), Fotografin, Autorin und Weltreisende. <span className='textAutor'>ILLUSTRATION: ANNABEL BRIENS</span>
            </figcaption>

            <p>
              Wenn Lesben nicht gerade jung und herzig sind, interessiert sich niemand
              für sie. Weil sie als hässlich gelten, als laut und kämpferisch. Und darum
              als überhaupt nicht weiblich. Ich benutze gern das Wort Kampflesbe. Denn
              nichts davon delegitimiert in Wahrheit unser Frausein: mega lesbisch sein,
              mega kämpferisch, mega laut. Und hässlich wie Nacht.
            </p>

            <p>
              Mit 17 hab ich mich in einen Typen verliebt. David, aus der oberen Mittelklasse,
              jeden Sonntagabend gab es bei ihm zu Hause Steak, wir haben abgemacht, dass wir mal
              heiraten. Als er sich nach drei Jahren trennte, blieb nur das Wissen, dass Verliebtsein
              und Sex etwas mega Schönes sind. Ich wollte das in die Welt hinaustragen.
            </p>

            <p>
              Anziehung war mein Lieblingsthema und ist es immer noch. Von romantischen
              Gefühlen bis hin zu Sexualität. Damals hatte ich das starke Bedürfnis nach einem
              Umfeld, das ein offenes Verständnis von Geschlecht hat. Ein Umfeld, das
               Weiblichkeit nicht abwertet, sondern feiert. Heute weiss ich: Ich wünschte mir
               einen queeren Freundeskreis, bevor ich selbst wusste, dass ich auf Frauen stehe.
            </p>

            <p>
              Als ich mit Anfang zwanzig dann ahnte, dass ich bisexuell bin, konnte ich mir
              trotzdem nicht vorstellen, eine Frau zu daten. Klar, bei den ganzen Hetero-Narrativen.
              Jedes Märchen, jedes Schulbuch, jede Werbung: mega hetero. Doch irgendwann gab es dann
              plötzlich Momente, in denen ich mich traute zu denken: Wow, ich stehe echt auf Frauen.
              Das bin ich.
            </p>

            <p>
              Den intensivsten dieser Momente hatte ich, als ich ein kurzes Buch von
              Annemarie Schwarzenbach las, «Eine Frau zu sehen», vor vier oder fünf
              Jahren. Sie beschreibt darin ihr Begehren, und es ist keine Interpretationssache.
              Der Text ist mega gay, auf ’ne mega schöne Art. Er hat nichts Schuldbehaftetes,
              sondern etwas Lustvolles. Und ich konnte alles nachempfinden. Wow, dachte ich,
              ich stehe echt auf Frauen.
            </p>

            <p>
              Schwarzenbach hat den Text in den 1930er-Jahren geschrieben. In einer Zeit,
              als es fast noch niemand tat, hat sie die Lesben sichtbar gemacht. Es hat mich
              mega geflasht zu lesen, dass es uns schon immer gegeben hat. Der Text erinnert
              mich daran, dass ich, solange ich mich als frauenliebende Frau exponiere, alles
              richtig mache.
            </p>

            <p>
              Dieser Gedanke half mir auch, als ich letztens zu spät zu einer Livesendung im
              Fernsehen kam. Ich sollte dort mit Benjamin Fischer von der Jungen SVP ein
              Streitgespräch führen über das Antidiskriminierungsgesetz, für das ich mich
              mit der Lesbenorganisation Schweiz einsetze. Ich hatte den Zug verpasst, war
              ungeschminkt, für die Maske blieb keine Zeit. Ich und meine Erwachsenenakne kamen
              also verschwitzt und ausser Atem zu spät ins Studio, ich war so sauer auf mich
              selbst – aber sogar da wusste ich: Ich bin eine queere Frau im Fernsehen. Und
              das gibt es viel zu selten. Ich mache also trotz allem einen guten Job.
            </p>

            <p>
              Dabei war Annemarie Schwarzenbach gar keine Aktivistin wie ich. Auch wenn es
              die damals schon gab. Vor dem Zweiten Weltkrieg blühte die queere Community in der
              Schweiz gerade auf. Schwarzenbach war nicht Teil davon. Aber sie war Journalistin,
              genau wie ich. Und sie starb sehr früh, mit Anfang dreissig, weshalb ich sie mir
              immer gleich alt wie ich vorstelle und mich mit ihr identifizieren kann.
            </p>

            <p>
              Allerdings war sie auch ein rich kid. In dem Text «Eine Frau zu sehen» macht sie
              Skiferien in einem Hotel in St. Moritz und schwärmt für eine Frau, die sie dort
              trifft. Es ist ein mega luxuriöses Setting, was dazu passt, dass Annemarie Schwarzenbach
              reich aufgewachsen ist. Und das bewundere ich nicht. Auch nicht, dass sie Drogen nahm.
              Ich vermute, sie konnte sich durch ihre Familie das ein oder andere «Privileg» rausnehmen.
            </p>
            <p>
              Trotzdem stellte sie sich gegen ihre Eltern, als die mit der Nationalen Front sympathisierten
              und sich den Nazis annäherten. Annemarie Schwarzenbach hatte viele jüdische Freunde und eine
              klar antifaschistische Haltung. Wenn das nicht so gewesen wäre, wüsste ich nicht, ob meine
              Faszination für sie und ihr Schreiben die gleiche wäre. Mein Vater ist jüdisch, mir liegt
              dieser Teil meiner Identität am Herzen. Und deshalb finde ich, dass es umso mehr über eine
              Person aussagt, wenn sie sich in dieser Zeit gegen ihre Familie und für ihre jüdischen Freunde
              entscheidet.
            </p>
            <p>
              Ich muss noch erwähnen, dass ich Annemarie Schwarzenbach mega hot finde. Wie sie rumlief,
              dieses Tomboy-Mässige. Noch immer bricht es mit vielen Normen, nicht klassisch weiblich
              aufzutreten. Würde Annemarie Schwarzenbach heute durch Zürich laufen, sie würde noch immer
              unhöflich angestarrt werden. Also stellen wir uns mal vor, wie das damals war! Sie hat die
              Normen ignoriert, und dafür bewundere ich sie. Wie gern würde ich mal was mit ihr trinken
              gehen. Dann würde ich drei Dinge sagen. Auf gut Schweizerdeutsch: Geile Siech! Ich würde
              ihr Danke sagen. Und ich würde sie anmachen. In dieser Reihenfolge.
            </p>

            <p className='textAutor'>PROTOKOLL: CARA WESTERKAMP</p>

        </div>

        <div
          className='ui container titleContainer'
          id='koerfer'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Lou Koerfer <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>GRETA THUNBERG</h2>
          <h4 className='titleTwo'>|&nbsp;Für den Schutz des Klimas demonstrieren – in Stockholm und in Zürich&nbsp;|</h4>
          <p className='autor'>
            LOU KOERFER (11) besucht die 5. Klasse der Gesamtschule Unterstrass in Zürich. Sie hat ihre
            Eltern und ihre zwei Geschwister davon überzeugt, einen Tesla zu kaufen und die Verwandten
            in Berlin nur noch per Nachtzug zu besuchen.
          </p>
        </div>

        <div className='ui text container'>

            <p>
              Vor ein paar Monaten machte ich einen Vortrag über Frauen, die die Welt
              verändern. Weil ich fand, dass wir in der Schule viel öfter über männliche
              Helden hören. Beim Recherchieren stiess ich auf Greta Thunberg, ich sah mir
              einige Videos an, und als ich mich da so durch die Auswahl klickte, guckte
              ich eins, in dem sie am Freitag zum Schulstreik fürs Klima aufrief.
            </p>

            <p>
              Während des letzten heissen Sommers hatten wir zu Hause viel über den
              Klimawandel geredet und was man selber dagegen tun kann. Als Familie
              wollten wir weniger Fleisch essen und weniger fliegen. Aber erst als
              ich sah, was Greta machte, wurde mir klar, dass man noch viel mehr tun
              muss, damit sich etwas ändert. Dass wir Kinder der ganzen Welt zeigen
              müssen, dass es unsere Zukunft ist, die auf dem Spiel steht, und dass
              wir nicht zulassen, dass die Erwachsenen sie weiter zerstören. Ich redete
              mit einigen Schulfreundinnen, und wir folgten im letzten Dezember Gretas
              Aufruf zum weltweiten Schulstreik. Seither habe ich an fast allen Streiks
              teilgenommen. Denn mir ist klar geworden, dass ich damit etwas verändern kann.
            </p>

            <p>
              Gretas Beispiel gibt mir aber auch in anderen Situationen, in denen ich
              Ungerechtigkeit sehe, das Gefühl, stark zu sein. Immer wenn ich von Greta rede,
              sage ich, sie ist mein grösstes Vorbild, denn so ist es auch. Greta hat mich so
              sehr beeinflusst wie niemand zuvor. Ich bin genauso besorgt um die Zukunft wie sie.
              Genau wie sie habe ich meinen Lebensstil geändert. In der Schule, wenn wir am
              Freitag selber kochen dürfen, tun wir das nur noch vegetarisch. Ich habe ebenfalls
              dem «Spick» und der «Sendung mit der Maus» geschrieben, dass sie Kinder mehr über
              den Klimawandel und «Fridays for Future» informieren sollen. Jedes Mal, wenn ich
              streike, weiss ich, Greta sitzt jetzt auch vor dem Parlament in Stockholm und streikt mit.
            </p>

            <p>
              Wir ziehen es beide durch.
            </p>

            <p>
              Da sie ein Mädchen ist, wird sie stärker kritisiert – daher finde ich es umso wichtiger,
              dass Mädchen in der Öffentlichkeit mehr ihre Meinung sagen, um zu zeigen, wir sind da und
              lassen uns nicht unterkriegen.
            </p>

            <p className='textAutor'>TEXT: LOU KOERFER</p>

        </div>

        <div
          className='ui container titleContainer'
          id='neff'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Jolanda Neff <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>JOHANNA VON ORLÉANS</h2>
          <h4 className='titleTwo'>|&nbsp;Das richtige Mindset: bereit sein, für eine Idee zu sterben&nbsp;|</h4>
          <p className='autor'>
            JOLANDA NEFF (26) ist eine der erfolgreichsten Velofahrerinnen der Welt. Im Mountainbiken
            ist sie Weltmeisterin und dreifache Gesamtweltcupsiegerin.
          </p>
        </div>

        <div className='ui text container'>

            <p>
              Als ich das erste Mal von Johanna von Orléans hörte, war ich noch ein Mädchen.
              Es war in der Primarschule, und ich fand einfach nur cool, dass wir ähnliche
              Vornamen haben. Mit der Zeit erfuhr ich mehr über ihr kurzes Leben, an der Sek,
              am Gymi, an der Uni. Ich bewundere Jeanne d’Arc, also Johanna von Orléans, so
              sehr – für ihren Mut, ihre Kraft, ihren unvergleichlichen Willen. In der Sportsprache
              sagen wir: ihr Mindset. Es heisst, man müsse bereit sein zu sterben, wenn man leben
              will – genau dafür steht sie.
            </p>

            <img
              src={neff.sources['1280w']}
              srcSet={neff.srcSet}
              sizes={'100vw'}
              alt='Johanna von Orléans (1412–1431), Heerführerin und französische Nationalheilige'
              className='ui fluid image'
            />
            <figcaption className=''>
              Johanna von Orléans (1412–1431), Heerführerin und französische Nationalheilige. <span className='textAutor'>ILLUSTRATION: ELENI KALORKOTI</span>
            </figcaption>

            <p>
              Johanna von Orléans war die Tochter eines Bauern, konnte weder lesen noch schreiben.
              Mit 17 zog sie aus, Frankreich zu retten, mitten im Hundertjährigen Krieg. Eine Frau an
              der Spitze einer Armee, vor sechshundert Jahren – das muss man sich einmal vorstellen.
              Sie drängte die Engländer tatsächlich zurück. Das war 1429.
            </p>

            <p>
              Zwei Jahre später war sie tot. Ein burgundischer Soldat hatte sie gefangen genommen
              und an die Engländer verkauft. Die verbrannten sie auf dem Scheiterhaufen.
            </p>

            <p>
              Johanna von Orléans inspiriert mich, aber es wäre absurd zu sagen, dass mein Leben
              nur ansatzweise etwas mit ihrem gemein hätte. Sie hat für ihr Land gekämpft, während
              ich einfach tue, was mir am besten gefällt. Trotzdem ziehe ich Motivation aus ihrer
              Geschichte.
            </p>
            <p>
              Es ist krass, wie minderwertig Frauen im Sport immer noch behandelt werden. Wenn ich
              erzähle, ich sei Veloprofi, heisst es: «Dann fährst du auch die Tour de France?» Eben
              nicht! Für Frauen gibt es keine Tour de France! Wenn wir überhaupt etwas verdienen,
              dann einen Bruchteil dessen, was die Männer bekommen, und wir können von Glück reden,
              wenn das Fernsehen irgendwann mitten in der Nacht wenigstens eine Kürzestzusammenfassung
              unserer Rennen zeigt.
            </p>
            <p>
              Ich verrate Ihnen etwas: Frauenrennen sind ebenso spannend wie Männerrennen, zwei Minuten
              nach dem Start erfolgt die erste Attacke, es wird zugefahren, attackiert, zugefahren,
              bis ins Ziel.
            </p>

            <p>
              Seit diesem Jahr fahre ich für Trek-Segafredo, ein Team mit einer langen Geschichte
              im Männerradsport. Nun wollen sie es auch bei den Frauen versuchen, und ich bin sehr
              stolz, dabei zu sein. Das heisst nicht, dass nicht auch innerhalb des Teams noch
              Überzeugungsarbeit geleistet werden müsste.
            </p>

            <p>
              Anfang Saison waren wir mit den Männern im Trainingslager, viele von ihnen sahen
              wahrscheinlich zum ersten Mal eine Velofahrerin aus der Nähe. Dass manche uns nicht
              für voll nahmen, erkannte man an ihren Blicken. Doch dann, während einer Trainingsausfahrt,
              machten wir ein kleines Rennen, zehn Minuten Vollgas, wir Frauen blieben einfach dran. Wir
              fuhren nicht gerade vorne im Wind, aber in der Gruppe – da hielten wir mit. Die Männer
              staunten nicht schlecht! Ich glaube, da haben einige ihre Meinung revidiert. Ein schöner Moment.
            </p>

            <p className='textAutor'>PROTOKOLL: CHRISTOF GERTSCH</p>

        </div>

        <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === Waypoint.below) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event' : 'Interactions',
              'event_action' : 'vertical-scroll',
              'event_label' : '50ContentRead'
            }
            )
          }
        }} />

        <div
          className='ui container titleContainer'
          id='falk'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Francesca Falk&nbsp;</span>über</p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>LILIANE VALCESCHINI</h2>
          <h4 className='titleTwo'>|&nbsp;Von Italienerinnen abschauen, wie man für seine Rechte kämpft&nbsp;|</h4>
          <p className='autor'>
            FRANCESCA FALK (42) ist Oberassistentin im Departement Zeitgeschichte an der Universität Freiburg.
          </p>
        </div>

        <div className='ui text container'>

            <p>
              Der Frauenstreik von 1991 hatte viele Mütter, ein Streik zeichnet sich ja
              dadurch aus, dass er kollektiv stattfindet. Aber eine hatte am Anfang die Idee,
              und das war Liliane Valceschini, eine Uhrmacherin.
            </p>

            <p>
              Sie arbeitete im Vallée de Joux und war eine von damals rund tausend Frauen
              in der lokalen Uhrenindustrie. Sie wagte es, den Lohnunterschied zwischen den
              Geschlechtern zu thematisieren: Frauen verdienten damals unter 3500 Franken
              im Monat, Männer zwischen 3500 und 5000 Franken – bei gleichen Arbeitsaufgaben.
              Konkreter Auslöser des Streiks war die absurde Tatsache, dass sogar männliche
              Auszubildende mehr verdienten als die Ausbildnerinnen. Liliane Valceschini
              schrieb das Gedicht «Si maman faisait grève …», darin formulierte sie ihre
              Motivation. Als Historikerin interessiert mich an dieser Geschichte, dass
              Liliane, Jahrgang 1937, die Tochter eines eingewanderten Italieners ist. Ich
              glaube, es ist kein Zufall, dass gerade sie die Idee hatte zu streiken, gibt
              es doch in Italien eine andere Streikkultur als in der Schweiz.
            </p>

            <p>
              Migration wird heute oft als Gefahr für die Gleichberechtigung der Geschlechter
              interpretiert. Aber ein Blick in die Geschichte zeigt, dass es oft umgekehrt war.
              Bei der Bildung ist es am deutlichsten: Die Schweiz erlaubte zwar als eines der
              ersten Länder Frauen den Zugang zu Universitäten, es waren allerdings russische
              Studentinnen, die das erkämpften. Die erste Frau, die in der Schweiz doktorierte,
              war 1867 die gebürtige Russin Nadeschda Suslowa. Die erste gebürtige Schweizerin,
              die in Medizin promovierte, war Marie Heim-Vögtlin. Inspiriert wurde Vögtlin
              nachweislich von Suslowa. Im «Historischen Lexikon der Schweiz» fehlt bei Marie
              Heim-Vögtlin aber ein Verweis auf Suslowa, und beim Eintrag von Suslowa ist zu
              lesen, sie habe viele Russinnen inspiriert – dass sie auch ein Vorbild für
              Schweizerinnen war, wird nicht erwähnt. Auch die erste Professorin der Schweiz –
              die Philosophin Anna Tumarkin – stammte aus dem russischen Reich.
            </p>

            <p>
              In der Politik spielten Einwandererinnen ebenso eine wichtige Rolle. Die
              prominenteste Figur ist vielleicht Ottilia Paky-Sutter aus Appenzell Innerrhoden.
              1947 verlor Sutter ihre Schweizer Staatsbürgerschaft, weil sie einen Österreicher
              heiratete. Sie musste sich wieder einbürgern lassen, was ein teurer und demütigender
              Prozess war. Daraufhin gründete sie 1978 eine Frauengruppe und kämpfte für das
              Frauenstimmrecht, das Appenzell Innerrhoden erst 1990 als letzter Kanton einführte.
              Nun war Paky-Sutter zwar eine gebürtige Schweizerin, aber durch die Heirat mit
              einem Ausländer machte sie das, was ich in meiner Forschung eine «indirekte»
              Migrationserfahrung nenne.
            </p>

            <p>
              In der wissenschaftlichen Literatur liest man, die Migration der Nachkriegszeit
              habe traditionelle Geschlechterverhältnisse verstärkt. Meine Forschung eröffnet
              eine neue Perspektive. Nehmen wir das Beispiel der Kinderkrippen. Es waren
              vorwiegend migrantische Familien, bei denen sich die Frage nach der Vereinbarkeit
              von Beruf und Familie stellte, da oft beide Elternteile arbeiteten. Als in der
              wirtschaftlichen Rezession nach der Ölkrise viele Migrantinnen und Migranten in
              ihre Herkunftsländer zurückkehren mussten, wurde die Betreuungsstruktur von
              anderen genutzt und zunehmend breiter akzeptiert.
            </p>

            <p>
              Oft heisst es, italienische Frauen hätten erst in der «moderneren» Schweiz ihre
              Freiheit entdeckt. Dabei unterschlägt man, dass Frauen in Italien in vielem –
              nicht allem – besser dastanden als in der Schweiz. Das Frauenstimmrecht galt in
              Italien seit Ende des Zweiten Weltkriegs, die Geschlechtergleichheit wurde viel
              früher in der Verfassung verankert. Die Italienerinnen trafen also in der Schweiz
              auf eine rückständige Situation. Ich kenne das von meiner eigenen Mutter, die in
              den 1970er-Jahren aus Italien einwanderte. Sie kam aus einem städtischen,
              politisierten Umfeld und war schockiert, als ich in der Schule als Mädchen
              automatisch ins Kochen und in die Hauswirtschaft eingeteilt wurde und die
              Knaben in die Geometrie und ins technische Zeichnen.
            </p>

            <p>
              Es ist erstaunlich, wie sehr die Gleichberechtigung in der Schweiz durch
              Einwanderinnen und Einwanderer geprägt ist.
            </p>

            <p>
              Gleichberechtigung ist übrigens niemals einfach eine Frage der Zeit, vielmehr
              ist unsere heutige Situation das Resultat von hartnäckigen Kämpfen und viel Mut.
              Deshalb ist Liliane Valceschini, die Uhrmacherin, für mich ein Vorbild.
            </p>

            <p className='textAutor'>PROTOKOLL: MIKAEL KROGERUS</p>

        </div>


        <div
          className='ui container titleContainer'
          id='carobbio'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Marina Carobbio <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>MARIE CURIE</h2>
          <h4 className='titleTwo'>|&nbsp;Aus dem Schatten des Mannes treten: zweimal den Nobelpreis gewinnen&nbsp;|</h4>
          <p className='autor'>
            Die Tessinerin MARINA CAROBBIO GUSCETTI (52) präsidiert seit November 2018 den
            Nationalrat und ist damit amtshöchste Schweizerin. Sie hat bis vor kurzem als
            Hausärztin gearbeitet und ist Vizechefin der SP Schweiz.
          </p>
        </div>

        <div className='ui text container'>

            <p><span className='question'>Das Magazin: Frau Nationalratspräsidentin, vielleicht ist es Ihnen auch schon passiert. Wenn Sie angerufen werden, dass man «noch eine Frau brauche» für eine Talkshow, ein Panel oder ein Gremium – gehen Sie da an die Decke?
              </span><br />
              Marina Carobbio Guscetti: Keineswegs. So wenig wie ich glaube, dass ich da nur
              wegen meines Geschlechts eingeladen werde, glaube ich, dass Männer nur wegen
              ihrer Kompetenz eingeladen werden. Ich nehme gerne an. Es gibt viele gute Frauen,
              sie müssen sich nur zeigen.
            </p>

            <img
              src={carobbio.sources['1280w']}
              srcSet={carobbio.srcSet}
              sizes={'100vw'}
              alt='Marie Curie (1867–1934), polnisch-französische Physikerin und Chemikerin'
              className='ui fluid image'
            />
            <figcaption className=''>
              Marie Curie (1867–1934), polnisch-französische Physikerin und Chemikerin. <span className='textAutor'>ILLUSTRATION: ALEXANDRA COMPAIN-TISSIER</span>
            </figcaption>

            <p><span className='question'>Wenn man Sie nach Ihrem Vorbild fragen würde, wer käme Ihnen in den Sinn?
              </span><br />
              Ich habe mehrere weibliche Vorbilder, aber am wichtigsten, vor allem während
              meiner Jugend, war mir die Wissenschaftlerin Marie Curie, die erst einen
              Nobelpreis für Physik erhielt und später auch einen für Chemie. Als Teenager
              habe ich mehrere Biografien von ihr gelesen. Später kam dann Simone de Beauvoir dazu.
            </p>

            <p><span className='question'>Was fasziniert Sie an Marie Curie?
              </span><br />
              Mich hat ihr Kampf für ihre Forschung, aber auch für ihre Anerkennung als Forscherin
              gefesselt. Sie war die erste Professorin an der Sorbonne. Und später, nach dem Tod
              ihres Mannes, verweigerte man ihr den Beitritt an die Académie des sciences. Was mich
              auch fasziniert: dass Marie Curie aus armen Verhältnissen stammte, dann nach Paris
              ging, studierte und zusammen mit ihrem Mann eine Riesenkarriere aufbaute.
            </p>

            <p><span className='question'>Das ist ja auch eine sehr romantische Geschichte.
              </span><br />
              Darum ging es mir nicht. Mich faszinierte der starke Wille dieser Frau. Und
              ihr Erfolg in der Forschung. Sie schaffte es in einem für Frauen sehr schwierigen
              Milieu. Und gewann sogar zweimal den Nobelpreis. (Marie Curie ist neben Linus
              Pauling die einzige Person, die den Nobelpreis in zwei verschiedenen Fachgebieten
              gewonnen hat.) Für mich war Curie ein Vorbild für den feministischen Willen.
            </p>

            <p><span className='question'>Was bedeutet für Sie feministischer Wille? Es gibt ja zahlreiche Versionen und Generationen des Feminismus.
              </span><br />
              Lange wurde Curie ja nur als Frau ihres Gatten gesehen. Davon hat sie
              sich befreit. So hat sie dazu beigetragen, dass Frauen in Forschung und Lehre anerkannt wurden.
            </p>

            <p><span className='question'>Ihr Vater, Werner Carobbio, ist ein bekannter Politiker – ein im
              Tessin äusserst populärer, eigensinniger Sozialdemokrat, der Ende Sechzigerjahre seine eigene
              Partei gründete, den Partito socialista autonomo.
              </span><br />
              Ich musste mich lange von seinem Erbe freischaufeln. Meine Mutter Graziella
              war glücklicherweise auch schon aktiv in der Frauenbewegung der 1970er- und
              1980er-Jahre. Ich kann mich erinnern, dass in unserer Küche ein Plakat hing,
              auf dem die Arbeitsstunden im Haushalt aufgelistet waren, um auf die unbezahlte
              Arbeit hinzuweisen.
            </p>

            <p><span className='question'>Weiter als Ihr Vater haben Sie es bereits geschafft. Er war Nationalrat, Sie sind Nationalratspräsidentin. War Ihre Mutter auch berufstätig?
              </span><br />
              Nein, sie war Hausfrau. Wir waren eine klassische Tessiner Familie der 1970er-, 1980er-Jahre.
            </p>

            <p><span className='question'>War die Rollenverteilung im Tessin damals anders als im Rest der Schweiz?
              </span><br />
              Ich kann nur für heute sprechen. Was ich sehe, lässt mich denken: Es gibt noch viel zu tun für die Gleichberechtigung. Die Männer im Tessin arbeiten beispielsweise noch seltener Teilzeit für die Erziehung.
            </p>

            <p><span className='question'>Hatte Ihre Mutter sich den Beruf Hausfrau ausgesucht?
              </span><br />
              Sie sagt immer, sie hätte gern studiert. Aber sie kam aus einfachen Verhältnissen und musste deshalb früh arbeiten gehen. Mein Vater kam auch aus einfachen Verhältnissen, studierte aber und wurde Lehrer.
            </p>

            <p><span className='question'>Wie sehen Sie das: Ist Kehren, Putzen, Wickeln weniger wert als die Arbeit ausser Haus?
              </span><br />
              Nicht, wenn es den freien Entscheid gibt, wer die notwendigen Hausarbeiten
              übernimmt. Natürlich ist es nicht gut, wenn eine Frau mit Ausbildung zu
              Hause bleibt, nur wegen der klassischen Rollenverteilung. Aber was bei
              uns wirklich fehlt, ist die Anerkennung der Hausarbeit in der Sozialversicherung.
              Es gibt zwar ein Kreditsystem in der AHV, wenn man sich um die Erziehung der
              Kinder kümmert, aber viele Frauen, die zu Hause arbeiten oder kleine
              Berufstätigkeiten ausüben wie beispielsweise Putzen, erhalten später
              weniger Rente. Das ist eine Folge der mangelnden Anerkennung. Nicht nur
              im Sinne von Würde, sondern auch materiell. Diese Stunden müssen zählen.
              Denn sonst bringt die Entscheidung, den Beruf für ein paar Jahre zurückzustellen,
              um sich der Erziehung zu widmen, nachher sehr grosse Verluste.
            </p>

            <p><span className='question'>Arbeiten Sie eigentlich heute noch als Ärztin?
              </span><br />
              Als Vizepräsidentin des Nationalrats konnte ich gelegentlich noch einspringen.
              Aber derzeit pausiere ich. Das Amt als Nationalratspräsidentin lässt mir keine
              Zeit mehr.
            </p>

            <p><span className='question'>Wann sind Sie eigentlich in die Politik gegangen?
              </span><br />
              Eigentlich begann es schon im Gymnasium. 1991, noch als Studentin, wurde ich
              dann angefragt, ob ich auf unsere Parteiliste im Tessin wollte. Natürlich ging
              es da auch um den Namen meines Vaters, den ich trug.
            </p>

            <p><span className='question'>1991 wurden Sie ja dann in den Tessiner Grossrat gewählt. Wie war das, dort einzulaufen?
              </span><br />
              Es war toll. Aber ich erinnere mich, wie es mich nervte, als eine Zeitung
              damals beschrieb, wie wir, die gewählten Frauen, angezogen waren. Das war
              ärgerlich, in so eine Rolle gedrückt zu werden.
            </p>

            <p><span className='question'>Haben Sie bei der Zeitung angerufen?
              </span><br />
              Ich habe damals nicht reagiert. Ich wollte mich durch mein Handeln beweisen.
              Anfangs wurde ich auch immer wieder mit meinem Vater verglichen. Davon
              musste ich mich befreien.
            </p>

            <p><span className='question'>Glauben Sie, dass dieser Beweisdruck zu grösseren Leistungen anspornt?
              </span><br />
              Das geht vielen Frauen so, nicht nur mir – durch harte Arbeit muss
              man beweisen, dass man etwas will und auch kann. Marie Curie musste
              für ihren Erfolg eindeutig mehr arbeiten als die Männer. In den
              Biografien fand ich nichts darüber, ob sie sich auch noch um die
              Erziehung gekümmert hat. Ihr Mann ist ja plötzlich verstorben, sie
              war praktisch alleinerziehend.
            </p>

            <p><span className='question'>Sie haben zwei Kinder und sind verheiratet.
              </span><br />
              Ich hatte eine Chance, weil mein Mann mich zu Hause unterstützt.
              Wenn ich in Bern arbeite, kann ich nicht jeden Abend heimkommen.
            </p>

            <p><span className='question'>Muss also einer zurückstecken?
              </span><br />
              Mein Mann hat immer gearbeitet. Er war auch ab und zu unterwegs. Aber es ist nicht immer einfach.
            </p>

            <p><span className='question'>Inwiefern hat Marie Curie Sie politisch inspiriert?
              </span><br />
              Als ich sah, wie zäh bei uns in Bern die Debatte zur Lohngleichheit
              verlief, wurde mir klar, dass noch viel zu tun ist. Es gab sogar Rückschläge.
              Ich bin schon etwas enttäuscht, wie lange alles dauert. Hoffentlich erhöht
              sich der Frauenanteil im Nationalrat und im Ständerat bei der Wahl im Oktober.
            </p>

            <p><span className='question'>Haben Sie konkrete Massnahmen für die Gleichberechtigung ergriffen?
              </span><br />
              Wir haben anlässlich des Frauentags am 7. März 2019 einen Anlass organisiert,
              bei dem wir mehrere Rednerinnen einluden, darunter zwei der ersten weiblichen
              Parlamentsmitglieder, und die Namen der Pionierinnen auf den Pulten eingravieren
              liessen, an denen sie 1971 sassen. Darüber hinaus habe ich mit den Parlamentsdiensten
              eine Webseite aufgebaut: Politfrauen. Sie soll Frauen ermutigen, in der Politik aktiv zu werden.
            </p>

            <p><span className='question'>Keine Gesetzesinitiativen oder andere Vorstösse?
              </span><br />
              Als Präsidentin des Nationalrats mache ich das nicht. Selbstverständlich
              habe ich, bevor ich dieses Amt annahm, auch Vorstösse im Bereich Gleichstellung
              eingereicht. Zurzeit will ich das Thema sichtbar machen im Parlament. Ich
              bin nicht allein mit solchen Aktionen. Schauen Sie mal (zeigt Handybilder).
              Als ich kürzlich ins italienische Parlament in Rom eingeladen war, zeigte man
              mir eine Bilderwand. Die hat Laura Boldrini, Präsidentin der Camera dei Deputati,
              installieren lassen. Porträts der ersten Frauen im italienischen Parlament. Und
              daneben hingen diese leeren Rahmen. Darunter standen Positionen, die bisher noch
              keine Frau innehatte. Und im Rahmen war ein Spiegel.
            </p>

            <p><span className='question'>Was haben die Frauen bei uns eigentlich noch nicht erobert?
              </span><br />
              Was noch fehlt, ist eine Frauenmehrheit im Parlament.
            </p>

            <p className='textAutor'>INTERVIEW: HANNES GRASSEGGER</p>

        </div>

        <div
          className='ui container titleContainer'
          id='kureyshi'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Meral Kureyshi <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>MERET OPPENHEIM</h2>
          <h4 className='titleTwo'>|&nbsp;Seine eigene Welt erschaffen und sich künstlerisch immer weiter vorwagen&nbsp;|</h4>
          <p className='autor'>
            MERAL KUREYSHI (36) studierte am Schweizerischen Literaturinstitut in Biel.
            Ihr Debütroman «Elefanten im Garten» erschien 2015, wurde in mehrere Sprachen
            übersetzt und schaffte es auf die Shortlist des Schweizer Buchpreises.
          </p>
        </div>

        <div className='ui text container'>

            <img
              src={kureyshi.sources['1280w']}
              srcSet={kureyshi.srcSet}
              sizes={'100vw'}
              alt='Meret Oppenheim (1913–1985), Lyrikerin und Künstlerin des Surrealismus'
              className='ui fluid image mobile only'
            />
            <figcaption className='mobile only'>
              Meret Oppenheim (1913–1985), Lyrikerin und Künstlerin des Surrealismus. <span className='textAutor'>ILLUSTRATION: KATRIN FUNCKE</span>
            </figcaption>

            <p>
              «Dort unten steht der Oppenheim-Brunnen», sagt Meral Kureyshi und zeigt
              aus dem Fenster ihres Schreibateliers. Eine hohe Säule, an der spiralförmig
              Wasser hinunterfliesst, auf dem Berner Waisenhausplatz. Es ist eines der
              bekanntesten und gleichzeitig umstrittensten Werke von Meret Oppenheim.
              Mehrere Jahrzehnte ihres Lebens verbrachte die Künstlerin in Bern, 1983
              schuf sie den Brunnen. Im selben Jahr wurde Meral Kureyshi in Prizren
              geboren, neun Jahre später kam sie mit ihrer Familie aus dem ehemaligen
              Jugoslawien nach Bern. Sie liebt den Brunnen, seit sie ihn zum ersten Mal gesehen hat.
            </p>

            <img
              src={kureyshi.sources['1280w']}
              srcSet={kureyshi.srcSet}
              sizes={'100vw'}
              alt='Meret Oppenheim (1913–1985), Lyrikerin und Künstlerin des Surrealismus'
              className='ui fluid image mobile hidden'
            />
            <figcaption className='mobile hidden'>
              Meret Oppenheim (1913–1985), Lyrikerin und Künstlerin des Surrealismus. <span className='textAutor'>ILLUSTRATION: KATRIN FUNCKE</span>
            </figcaption>

            <p><span className='question'>Das Magazin: Was mögen Sie an Meret Oppenheim?
              </span><br />
              Mit zwanzig haute sie von zu Hause ab, lernte in Paris die Surrealisten
              kennen, die sie später als grosse Saubande bezeichnete, Max Ernst, Alberto
              Giacometti und viele andere. Sie war hingerissen von den Männern, aber
              liess sich nie etwas von ihnen diktieren. Sie war dieses androgyne Wesen,
              das sich allen gesellschaftlichen Konventionen entzog. «Die Freiheit wird
              einem nicht gegeben, man muss sie nehmen», schrieb sie. Sie hat sich ihre
              Freiheit erkämpft, und das brauchte Kraft. Sie hat getan, was sie als dringlich
              empfand. Grossen Einfluss hatte ihre Grossmutter Lisa Wenger, die selbst
              Schriftstellerin und Malerin war.
            </p>

            <p><span className='question'>Oppenheims wahrscheinlich bekanntestes Werk ist die Pelztasse.
              </span><br />
              Die Tasse war ihr Durchbruch, sie wurde zum Modellfall für den Surrealismus.
              Später erklärte sie, sie habe die Tasse, den Unterteller und den Löffel ohne
              jegliche Intention mit dem Fell einer Gazelle überzogen. Das hinderte natürlich
              niemanden daran, alles Mögliche hineinzuinterpretieren. Aber das war nun mal ihr
              Instrument. Jeder hat sein eigenes Instrument, seinen Gefühlen Ausdruck zu geben.
            </p>

            <p><span className='question'>Ihr Instrument ist das Schreiben.
              </span><br />
              Als wir Kinder waren, hat mein Bruder gezeichnet, ich habe geschrieben,
              ganze Notizbücher voll. Ich sah etwas und schuf mit Worten ein Bild,
              versuchte es so exakt zu beschreiben, dass ich mich auch Jahrzehnte später
              würde daran erinnern können. Ich wollte meinen Empfindungen eine Sprache
              geben. Noch heute bin ich mit einem Notizbuch unterwegs, lausche den
              Gesprächen im Bus, beschreibe, wie die Leute aussehen, wie ihre Stimme
              klingt, wie sie riechen, ihren Blick.
            </p>

            <p><span className='question'>Schreiben Sie gern?
              </span><br />
              Es fängt mit einer Beschreibung an, einer Idee, daraus entsteht langsam
              eine Geschichte. Es folgt eine Reise, auf der ich viel lerne. Ich verändere
              meine Sichtweisen. Auch ich selbst verändere mich, manchmal zu jemandem,
              den ich nicht gern mag. Die verschiedenen Perspektiven eröffnen neue
              Eindrücke, es entstehen andere Welten, ich gehe immer weiter. Aber am
              Ende ist es ein Kampf, den Schreibprozess als solches mag ich nicht so
              sehr. Ich glaube, Meret Oppenheim ging es ähnlich. Sie sagte einmal,
              aus einem Spiel entstehe Ernst. Das finde ich eine schöne Vorstellung.
            </p>

            <p><span className='question'>Kommt es vor, dass Sie beim Schreiben aus dem
            Fenster schauen und an Meret Oppenheim denken?
              </span><br />
              Der Brunnen kommt in meinem nächsten Roman «Fünf Jahreszeiten» vor. Ich sehe
              jeden Tag, wie er sich verwandelt, so langsam, dass ich den Moment der
              Veränderung verpasse. Ich glaube, es liegt daran, dass ich blinzle. Im
              Sommer denkt man, dass das Moos am Brunnen gleich austrocknet, und im
              Winter kann man beobachten, wie auf dem Glatteis die Menschen ausrutschen
              und umfallen. Die Touristen stehen verwirrt vor dem Brunnen, sie wissen
              nicht, ob sie den «Störenfried» fotografieren sollen oder nicht. Ein
              Störenfried – so würden meine Freunde wohl auch mich bezeichnen. Auch
              die Figuren in meinen Geschichten wollen sich nicht anpassen, sie
              passen nicht ins Bild.
            </p>

            <p><span className='question'>War Meret Oppenheim auch ein Störenfried?
              </span><br />
              Sie passte wohl auch nicht ins Bild der Zeit. Man Ray fotografierte sie
              nackt, es wurde ein Skandal. Das war eine bewusste Provokation. Es braucht
              solche Frauen, damit sich etwas grundsätzlich verändert. Meret Oppenheim
              hatte aber auch Angst, das Handwerk nicht zu beherrschen. Als sie nach dem
              Zweiten Weltkrieg in die Schweiz zurückkam, in ihren Dreissigern, beschloss
              sie, die Kunsthochschule in Basel zu besuchen. Bis dahin hatte sie sich
              alles selbst beigebracht – nun meinte sie, sie könne nichts und müsse
              es erlernen. Die Angst kann ich gut nachvollziehen.
            </p>

            <p><span className='question'>Was tun Sie gegen diese Angst?
              </span><br />
              Einen Roman veröffentlichen.
            </p>

            <p><span className='question'>Werden Sie als Frau im Literaturbetrieb von Kollegen blöd angemacht?
              </span><br />
              Ja, auch auf der Bühne. Und wenn man sich wehrt, wird man nicht mehr eingeladen. Mir
              ist das egal. Ich sage, was ich denke, und fürchte mich nicht vor Grossmäulern. Ich
              werde «Früchtchen» genannt oder gefragt, ob ich für die Schminke zuständig sei. Könnten
              Sie, hübsches Fräulein, mir ein Glas Wasser bringen? – Nein, antworte ich meistens:
              Wir werden später auf der Bühne die Möglichkeit haben, über Diskriminierung zu sprechen.
              Sie können doch sicher, sage ich weiter, über meine roten Lippen, meinen Ausschnitt
              und meine Schenkel hinwegschauen und ein geistreiches Gespräch mit mir führen, oder nicht?
            </p>

            <p className='textAutor'>INTERVIEW: CHRISTOF GERTSCH</p>

        </div>

        <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === Waypoint.below) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event' : 'Interactions',
              'event_action' : 'vertical-scroll',
              'event_label' : '75ContentRead'
            }
            )
          }
        }} />

        <div
          className='ui container titleContainer'
          id='theus'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Tilla Theus <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>ZAHA HADID</h2>
          <h4 className='titleTwo'>|&nbsp;Immer bessere Häuser bauen – und sein eigener Massstab sein&nbsp;|</h4>
          <p className='autor'>
            TILLA THEUS (75) ist die erste Schweizer Architektin, die auch internationale Bekanntheit
            erlangt hat. Zu ihren Bauten gehören der FIFA-Hauptsitz und das Widder Hotel in Zürich
            sowie das preisgekrönte Gipfelrestaurant auf dem Weisshorn.
          </p>
        </div>

        <div className='ui text container'>

            <p>
              Als ich in den Sechzigerjahren an der ETH in Zürich Architektur studierte,
              gab es kaum Frauen. Keine Professorinnen, keine bekannten Architektinnen, an
              denen wir uns hätten orientieren können, auch keine unbekannten Architektinnen,
              die zu entdecken gewesen wären. Unser Zugang zum Reich der Architektur waren die
              Bücher und Zeitschriften in der Departementsbibliothek und die Vorlesungen der
              Professoren, die von den durchweg männlichen Göttern am Himmel der Bauwelt
              sprachen: Frank Lloyd Wright, Alvar Aalto, Carlo Scarpa. Sie waren auch meine
              eigenen Götter, die ich bewunderte, weil sie sich auch mit den Innenräumen
              befassten, die Atmosphäre bedachten und vermeintliche Details wie Möbel,
              Lampen, Teppiche mitgestalteten. Dass das Bauen Männersache war, hat mich
              damals nicht irritiert, denn ich kannte es nicht anders. Es war schlicht
              und ergreifend so.
            </p>

            <img
              src={theus.sources['1280w']}
              srcSet={theus.srcSet}
              sizes={'100vw'}
              alt='Zaha Hadid (1950–2016), irakisch-britische Architektin und erste Pritzker-Preisträgerin'
              className='ui fluid image'
            />
            <figcaption className=''>
              Zaha Hadid (1950–2016), irakisch-britische Architektin und erste Pritzker-Preisträgerin. <span className='textAutor'>ILLUSTRATION: ALINE ZALKO</span>
            </figcaption>

            <p>
              Was ich jedoch nicht akzeptieren konnte, war die Rolle, die den Frauen in dieser
              Welt zugedacht war. Die einzige Architektin, von der ich über Umwege erfuhr, war
              Lux Guyer, die vermutlich erste eigenständige Architektin der Schweiz. Sie baute
              zwischen den Dreissiger- und Fünfzigerjahren einige grossartige Einfamilienhäuser.
              Wie ihr das gelang? Sie konzipierte und errichtete solch ein Haus zunächst für sich
              selber und bewohnte es, um potenzielle Kunden von den Vorzügen des Hauses zu überzeugen.
              Hatte sie es verkauft, zog sie aus und baute sich das nächste Haus und wieder das nächste,
              weil sie sonst ohne Aufträge geblieben wäre. Das war zwar lange vor meiner Zeit, aber
              an der Grundhaltung gegenüber Architektinnen hatte sich wenig geändert. Frauen waren
              zuständig für Inneneinrichtung, für Küchen und Badezimmer. Das reichte mir nicht.
              Meine Ziele hatte ich mir höher gesteckt: Ich wollte nicht nur für einen Teil
              zuständig sein, sondern für alle Bereiche meiner Bauten.
            </p>

            <p>
              Der Weg dahin war schwer, aber darüber jammere ich nicht. Letztlich ist die
              zusätzliche Anstrengung, die ich im Wettbewerb mit Männern in meine Entwürfe
              gesteckt habe, stets der Qualität der Gebäude zugutegekommen. Als ich in meinem
              Beruf anfing, war das Frauenwahlrecht noch nicht eingeführt. Auch durfte ich
              ohne die Unterschrift des Ehemannes kein Bankkonto eröffnen. Daran wäre beinahe
              einer meiner ersten grösseren Aufträge gescheitert, weil sich der Bauherr auf
              den Standpunkt stellte, mir seien Vertragsabschlüsse untersagt. Das war hart.
              Ich war empört, als ich erfuhr, dass der von mir verehrte Alvar Aalto seine
              Gebäude gemeinsam mit seiner ersten Frau Aino und seiner zweiten Frau Elissa
              konzipierte, die Beteiligung seiner Partnerinnen jedoch verschwieg. Wann
              immer ich im Beruf wie im Privaten als Frau selbst Ungerechtigkeiten erlebte,
              führte ich dagegen einen Kampf. In aller Regel mit Erfolg.
            </p>

            <p>
              Und dann kam das Jahr 1986. Lis Schwarz, die als Gründerin des legendären
              Möbelgeschäfts «Neumarkt 17» als Erste internationales Design nach Zürich
              brachte, stellte Möbel von Zaha Hadid aus. Ich kannte einige ihrer Entwürfe
              für Bauwerke. Die freien Formen, ohne rechte Winkel, kühn und souverän,
              überzeugten mich. Deshalb störte es mich enorm, dass Zaha Hadid bislang
              noch keinen einzigen dieser Entwürfe verwirklichen konnte. Sie wurden als
              statisch unrealisierbar, als Hirngespinste abgeurteilt.
            </p>

            <p>
              Zur Vernissage ihrer Möbelausstellung kam Zaha Hadid nach Zürich. Ich werde
              diesen Auftritt nie vergessen: von Kopf bis Fuss in Schwarz, klein, voluminös
              und unglaublich präsent. Sie sprühte vor Energie und vor allem: Keine Sekunde
              schien sie daran zu zweifeln, dass ihre Entwürfe eines Tages endlich gebaut
              würden. Sie erzählte, dass sie Mathematik studiert habe und deshalb die Statik
              ihrer Gebäude selbst berechnen könne, besser als die Ingenieure, die ihre
              gewagten, komplexen Berechnungen nicht verstünden. Ich war fasziniert von
              dieser Frau, ihrer Courage und vor allem ihrer Zuversicht.
            </p>
            <p>
              Und sie hat recht behalten. Sieben Jahre nach unserer ersten Begegnung, da
              war sie 43 Jahre alt, baute sie ihr erstes Gebäude, eine Feuerwehrstation auf
              dem Gelände von Vitra Design in Weil am Rhein. Natürlich bin ich sofort hingefahren
              und war begeistert von den schiefen, spitz zulaufenden Betonwänden, den Räumen,
              die wirkten, als würden sie beschleunigen und jeden Moment abheben und fliegen.
            </p>

            <p>
              Zaha Hadid war eine geniale Baumeisterin, die ich bewundere und verehre.
              Doch noch stärker als ihr Können haben mich ihr Mut und ihr Kampfgeist mitgerissen.
            </p>

            <p className='textAutor'>PROTOKOLL: SVEN BEHRISCH</p>

        </div>

        <div
          className='ui container titleContainer'
          id='miller'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Barbara Miller <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>OLYMPE DE GOUGES</h2>
          <h4 className='titleTwo'>|&nbsp;Sich nicht von Männern unterdrücken lassen – weder rechtlich noch sexuell&nbsp;|</h4>
          <p className='autor'>
            BARBARA MILLER (49) ist Dokumentarfilmerin und Präsidentin des Verbands Filmregie und
            Drehbuch Schweiz. Ihr preisgekrönter Kinofilm «#Female Pleasure» begleitet fünf
            ausserordentliche Frauen rund um den Globus.
          </p>
        </div>

        <div className='ui text container'>
            <p>
              Während der Französischen Revolution, deren Errungenschaften nur für
              Männer galten, forderte Olympe de Gouges den Sturz der jahrtausendelangen
              patriarchalen Tyrannei: Sie verlangte die Gleichstellung von Mann und Frau.
            </p>

            <img
              src={miller.sources['1280w']}
              srcSet={miller.srcSet}
              sizes={'100vw'}
              alt='Olympe de Gouges (1748–1793) Revolutionärin'
              className='ui fluid image'
            />
            <figcaption className=''>
              Olympe de Gouges (1748–1793) Revolutionärin. <span className='textAutor'>ILLUSTRATION: DENISE NESTOR</span>
            </figcaption>

            <p>
              Ihre Lebensgeschichte unterscheidet sich auf den ersten Blick nicht
              on der anderer Frauen ihrer Zeit. Als Marie Gouze in einfache Verhältnisse
              geboren, wurde de Gouges mit 17 gegen ihren Willen verheiratet. Als Mutter
              eines Sohnes früh verwitwet, lebte sie danach lange in einer «wilden»
              Liebesbeziehung. In Paris brachte sie sich selbst Lesen und Schreiben bei
              und verfasste mit 26 unter einem Pseudonym ihre ersten kritischen Theaterstücke
              und eine Denkschrift gegen die Sklaverei. 1786 schrieb sie einen Briefroman, in
              dem sie die gesellschaftliche Ächtung lediger Mütter und das Scheidungsrecht
              kritisierte und das Recht auf Beziehungen ohne Trauschein verlangte.
            </p>

            <p>
              Unter dem Künstlernamen Olympe de Gouges verfasste sie im September 1791 die
              «Erklärung der Rechte der Frau und Bürgerin», die allerersten Menschenrechte für
              Frauen in der Geschichte der modernen Zivilisation. Vielleicht sogar die ersten
              der Menschheitsgeschichte.
            </p>

            <p>
              Von den diversen Verhaftungen liess sie sich nicht einschüchtern; schliesslich
              sorgte Revolutionsführer Robespierre persönlich dafür, dass de Gouges verhaftet
              wurde. 1793 wurde sie auf der Place de la Concorde durch die Guillotine hingerichtet.
            </p>
            <p>
              Olympe de Gouges ist für mich ein grosses Vorbild, weil für sie die Forderung
              «Frauenrechte sind Menschenrechte» eine Selbstverständlichkeit war. Sie sah sich
              selbst nicht als Revolutionärin, sondern als gewöhnlichen Menschen, der seine
              Forderungen analytisch formulierte und auf ein unumstössliches Fundament stellte.
              Für mich als Regisseurin und Juristin bildet dieses Fundament eine der wichtigsten
              Grundlagen meines Schaffens. Die in meinem Film «#Female Pleasure» porträtierten
              fünf Frauen stehen in Mut und Klarheit Olympe de Gouges nicht nach. Erschreckenderweise
              sind die Reaktionen auf ihre Forderung nach sexueller Selbstbestimmung heute manchmal
              nicht weniger martialisch als vor mehr als 200 Jahren.
            </p>
            <p>
              Zum Glück ist es heute nicht mehr nur eine einzelne Frau, die sich für Veränderungen
              einsetzt. Millionen Frauen und auch immer mehr Männer glauben an ein gleichberechtigtes,
              respektvolles und lustvolles Miteinander.
            </p>

            <p>
              Die Dämonisierung und sexuelle Objektivierung von Frauen und ihres Körpers gehören
              endgültig auf den Scheiterhaufen der Geschichte. Bei uns hat die Gleichstellung im
              Gesetz 1981 – 190 Jahre nach de Gouges’ Manifest – Einzug gehalten: «Mann und Frau
              sind gleichberechtigt.» Nun muss das auf jeder Ebene selbstverständlich werden.
              Ganz in de Gouges’ Sinn von: Freiheit, Gleichheit und Menschlichkeit für alle.
            </p>

            <p className='textAutor'>TEXT: BARBARA MILLER</p>

        </div>

        <div
          className='ui container titleContainer'
          id='keller'
        >
          <div className='oberzeile'>
            <p><span className='bold'>Anne-Sophie Keller <span className='notbold'>über</span></span></p>
            <Scrollchor animate={{ offset: -10 }} to='#nav'>
              <div className='top-link' onClick={this.trackTopClicks}>
                <div className='arrow-text mobile hidden'>nach oben</div>{' '}
                <i className='icon angle double up' />
              </div>
            </Scrollchor>
          </div>
          <h2 className='title'>IRIS VON ROTEN</h2>
          <h4 className='titleTwo'>|&nbsp;Seiner Überzeugung treu bleiben und den härtesten Anfeindungen trotzen&nbsp;|</h4>
          <p className='autor'>
            ANNE-SOPHIE KELLER (29) arbeitet als Journalistin für das digitale Magazin «izzy» und publizierte
            2017 über Iris von Roten das Buch «Eine Frau kommt zu früh – noch immer?».
          </p>
        </div>

        <div className='ui text container'>

            <p>
              Ich habe ein bisschen geblufft. Damals, als meine Verlegerin Yvonne-Denise
              Köchli mich fragte, ob ich mit ihr ein Buch über Iris von Roten schreiben würde.
              Ich hatte den Namen schon gehört, aber eigentlich wusste ich wenig darüber, wer
              Iris von Roten wirklich war. Dass es vielen so geht, ist die Tragik ihres Lebens.
            </p>

            <img
              src={keller.sources['1280w']}
              srcSet={keller.srcSet}
              sizes={'100vw'}
              alt='Iris von Roten (1917–1990), Juristin und Feministin'
              className='ui fluid image'
            />
            <figcaption className=''>
              Iris von Roten (1917–1990), Juristin und Feministin. <span className='textAutor'>ILLUSTRATION: ELISABETH MOCH</span>
            </figcaption>

            <p>
              Iris von Roten hat niemals die Anerkennung bekommen, die sie verdiente.
              Dabei war sie hierzulande die grosse feministische Vorreiterin des letzten
              Jahrhunderts. Ihr mutiges Buch «Frauen im Laufgitter – offene Worte zur
              Stellung der Frau» war 1958 eine bahnbrechende Abrechnung mit der Gesellschaft.
              Es schaffte ein Bewusstsein für die beschämende Rückständigkeit, die die Schweiz
              in Frauenfragen bis heute prägt.
            </p>

            <p>
              Sie kam 1917 als Iris Meyer in Basel zur Welt, promovierte an der Universität
              Bern in Recht, damals noch eine seltene Frauenkarriere, und schrieb für das
              «Schweizer Frauenblatt» kritische Texte, mit denen sie sich nicht nur beliebt
              machte. Ein Vorgeschmack auf das, was kommen sollte.
            </p>

            <p>
              1946 heiratete sie Peter von Roten, doch sie wollte kein Leben als «Nurhausfrau»,
              wie sie es nannte. Also wurde sie von Rotens Partnerin in einer gemeinsamen Kanzlei.
              Später reiste sie in die USA und begann mit der Arbeit an «Frauen im Laufgitter». Es
              wurde ihr Lebenswerk. Ein kühnes Buch, seiner Zeit weit voraus.
            </p>

            <p>
              Sie war eine Frau, die alles wollte: Freiheit, beruflichen Erfolg, Abenteuer. Peter
              von Roten heiratete sie gegen den Willen seiner Familie; ihre Tochter Hortensia wurde
              früh fremdbetreut, und auch sonst lebte Iris von Roten ein Leben jenseits der Norm.
            </p>

            <p>
              Die Zeit würde ihr recht geben, aber als «Frauen im Laufgitter» erschien, traf sie
              mit ihren revolutionären Gedanken zu viele wunde Punkte: Setzer weigerten sich, das
              Buch zu drucken, Frauenverbände distanzierten sich von ihr, Fremde schmierten übelste
              Schimpfworte an ihre Hauswand, an der Fasnacht wurde sie gedemütigt.
            </p>

            <p>
              Viele Kritiker hatten das Buch gar nicht gelesen, der Hass richtete sich gegen
              ihre Person. Heute, da Hassreden ein gefährliches Comeback feiern, würde man es
              Shitstorm nennen. Besonders bitter: Wenig später, 1959, scheiterte auch die erste
              Abstimmung zum Frauenstimmrecht.
            </p>

            <p>
              Iris von Roten hatte von der Gesellschaft mehr erwartet. Sie zog sich zurück,
              ging auf Reisen, malte und verschwand fast ganz von der Bildfläche. Mit zunehmendem
              Alter litt sie unter gesundheitlichen Problemen und schweren Schlafstörungen. Durch
              den Verlust der Sehkraft konnte sie nicht mehr malen.
            </p>

            <p>
              Mit 73 Jahren befand sie, dass es Zeit war zu gehen. Am 11. September 1990
              erhängte sie sich. Sie schied aus dem Leben in derselben Art, wie sie es geführt
              hatte: selbstbestimmt. «Wie ein Ausrufezeichen nach einem besonders tapferen
              Satz», so beschrieb Peter von Roten den Tod seiner Frau.
            </p>

            <p>
              Würde Iris von Roten heute noch leben, was würde sie wohl denken? Klar, die
              Hauptforderungen aus «Frauen im Laufgitter» sind erfüllt. Mit der Pille erhielten
              Frauen in den 1960er-Jahren die reproduktive Selbstbestimmung. 1971 führte die
              Schweiz das Frauenstimmrecht ein. Die Gleichstellung der Geschlechter ist seit
              1981 in der Bundesverfassung verankert. 2002 trat die Fristenregelung in Kraft,
              die schwangeren Frauen eine legale Abtreibung bis zum Ende der zwölften Woche
              ermöglicht. 2005 wurde die Mutterschaftsversicherung eingeführt. Und doch ist
              unsere Denkweise noch immer gestrig. Das Dilemma der Vereinbarkeit von Beruf und
              Familie, der Pflegenotstand, sexuelle Übergriffe, allgegenwärtiger Sexismus, die
              Untervertretung von Frauen in Machtpositionen und Lohndiskriminierungen versperren
              weiterhin den Weg zur wahren Gleichstellung. Es sind allesamt Themen, die Iris von
              Roten schon damals erkannte und beschrieb.
            </p>

            <p>
              Feminismus ist eine Bewegung, die stets zwei Schritte nach vorne und einen
              zurück macht. Sich davon nicht entmutigen zu lassen, verlangt eine fast unmenschliche
              Zuversicht. Eine, die Iris von Roten nie hatte. Ich kann verstehen, dass sie verbittert
              wurde. Denn sie war ihrer Zeit nicht voraus. Ihre Zeit hinkte ihr hinterher.
            </p>

            <p>
              Als ihr Buch erschien, wurde sie als «Hure» beschimpft; als mein Buch erschien,
              wurde ich in einer Mail von einem Fremden als «Drecksfotze» bezeichnet. Es war
              nicht der erste und blieb nicht der letzte Angriff. Ich habe auf die harte Tour
              gelernt, dass andere Menschen einen als Projektionsfläche für ihren eigenen
              Schmerz und Frust missbrauchen, sobald man als Person auch nur ein bisschen
              öffentlich wird. Sich als Frau feministisch zu äussern, ist auch heute noch eine
              derartige Provokation, dass die Reaktionen darauf barbarisch sind. Auch ich bin
              fast kaputtgegangen daran. Aber ich habe weitergemacht. Das schulde ich ihr.
            </p>

            <p>
              An Iris von Roten bewundere ich die Konsequenz, mit der sie ihre Anliegen vertrat.
              Ihren Mut, anders zu leben. Und ihre absolute Kompromisslosigkeit, wenn es darum ging,
              ihre Freiheit zu verteidigen.
            </p>

            <p>
              Sie erhielt nicht annähernd genug vom Leben. Aber sie wollte alles. Und das finde ich bemerkenswert.
            </p>

            <p className='textAutor'>TEXT: ANNE-SOPHIE KELLER</p>

        </div>


        <Waypoint scrollableAncestor={window} onLeave={(event) => {
          if (event.currentPosition === Waypoint.above) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event' : 'Interactions',
              'event_action' : 'vertical-scroll',
              'event_label' : 'contentBottom'
            }
            )
          }
        }} />


        <Waypoint scrollableAncestor={window} onLeave={(event) => {
          if (event.currentPosition === Waypoint.above) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              'event' : 'Interactions',
              'event_action' : 'vertical-scroll',
              'event_label' : 'pageBottom'
            }
            )
          }
        }} />


        <Footer
          articleId={ARTICLE_ID}
          questions={['Wie gefällt Ihnen der Beitrag?','Wie ansprechend ist die Gestaltung?']}
          credits={[
            ['Idee und Konzept','Anuschka Roshani & Paula Scheidt, Das Magazin'],
            ['Digitale Umsetzung','Patrick Vögeli'],
          ]}
          mediaName="dasmagazin"
          fullMediaName="Das Magazin"
          starColor="black"
          displayPrivacyPolicyLink={false}
        />

      </div>
    )
  }
}

export default hot(module)(AppComponent)
